import { useId } from 'react'
import type { FieldElementsIds } from '../field'

interface UseFieldsAriaAttributesParams {
  ariaLabelledBy?: string
  error?: string
  helperLabel?: string
  label?: string
}

export const useFieldInputAria = ({
  ariaLabelledBy,
  error,
  helperLabel,
  label,
}: UseFieldsAriaAttributesParams) => {
  const uniqueId = useId()
  const fieldHeaderId = `${uniqueId}-header`
  const fieldErrorId = `${uniqueId}-error`
  const fieldHelperId = `${uniqueId}-description`

  const fieldElementsIds: FieldElementsIds = {
    fieldHeaderId,
    fieldErrorId,
    fieldHelperId,
  }

  const fieldInputAriaAttributes = {
    ...(error
      ? { 'aria-errormessage': fieldErrorId }
      : helperLabel
        ? { 'aria-describedby': fieldHelperId }
        : {}),
    ...(ariaLabelledBy ? { ariaLabelledBy } : label ? { ariaLabelledBy: fieldHeaderId } : {}),
  }
  return { fieldElementsIds, fieldInputAriaAttributes }
}
